"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBRecentSearch;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _svbReactComponents = require("@svb/svb-react-components");
var _clockStatusGrey = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/clock-status-grey.svg"));
var _Close = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Close.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function SVBRecentSearch(props) {
  const {
    recentSearchJson,
    removeRecentSearch,
    selectedRecentSearch,
    recentSearchLimit,
    extraClasses
  } = props;
  const finalClass = !extraClasses ? 'col-md-12' : extraClasses;
  const [initialRecentJson, setinitialRecentJson] = (0, _react.useState)([]);
  const limitRecentSearch = recentSearchLimit ? recentSearchLimit : 5;
  const removeThisItemDisplay = key => {
    let finalJson = initialRecentJson;
    finalJson = finalJson.filter(item => item.key !== key);
    setinitialRecentJson(finalJson);
  };
  (0, _react.useEffect)(() => {
    setinitialRecentJson(recentSearchJson.slice(0, limitRecentSearch));
  }, []);
  return initialRecentJson.length ? /*#__PURE__*/_react.default.createElement("div", {
    id: "recent-search",
    className: finalClass
  }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBTypography, {
    type: "sub-heading",
    variant: "small mb-2"
  }, "Recent Searches"), /*#__PURE__*/_react.default.createElement("ul", {
    className: "list-group"
  }, initialRecentJson.map((item, i) => {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: i,
      className: "list-group-item d-flex justify-content-between align-items-center border-0 rounded-0 ps-2 py-1"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "search-value"
    }, /*#__PURE__*/_react.default.createElement("img", {
      src: _clockStatusGrey.default,
      alt: "clock status icon",
      role: "status",
      width: "16",
      height: "16"
    }), /*#__PURE__*/_react.default.createElement("a", {
      className: "ms-3",
      href: "#",
      onClick: e => {
        e.preventDefault();
        selectedRecentSearch(item.value);
      }
    }, item.value)), /*#__PURE__*/_react.default.createElement("span", {
      className: "remove-icon",
      onClick: () => {
        removeThisItemDisplay(item.key);
        removeRecentSearch(item.key, item.value);
      }
    }, " ", /*#__PURE__*/_react.default.createElement("img", {
      src: _Close.default,
      alt: "clock status icon",
      role: "status",
      width: "20",
      height: "20"
    })));
  }))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
}
SVBRecentSearch.propTypes = {
  recentSearchJson: _propTypes.default.any,
  removeRecentSearch: _propTypes.default.func,
  selectedRecentSearch: _propTypes.default.func,
  recentSearchLimit: _propTypes.default.number,
  extraClasses: _propTypes.default.string
};